import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from 'context/authContext';
import paths from 'routes/paths';
import UrgentAppealForm from './urgent-appeal-form/UrgentAppealForm';
import useUpload from 'hooks/useUpload';
import { useCreateUrgentAppeal } from 'hooks/useUrgentAppeals';

function CreateUrgentAppeal() {
  const navigate = useNavigate();
  const { organization, selectedBranchId } = useAuthContext();
  const { createUrgentAppealAsync, isCreating } = useCreateUrgentAppeal();
  const { upload, loading: uploadLoading } = useUpload();

  const onSubmit = async data => {
    let image = data.images;
    try {
      if (image && typeof image !== 'string') {
        const profileUrl = await upload(image);
        image = profileUrl;
      }
    } catch (e) {
      toast.error('Something went wrong! Please Try again later!');
      return;
    }
    try {
      await createUrgentAppealAsync({
        ...data,
        branch_id: selectedBranchId,
        organisation_id: organization.id,
        images: { primary: image },
        is_display: false
      });
      navigate(paths.urgentAppeals);
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <UrgentAppealForm onSubmit={onSubmit} loading={isCreating || uploadLoading} />
  );
}

export default CreateUrgentAppeal;
